var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34175 17.9957V9.78697H8.99518L9.39245 6.58787H6.34175V4.54535C6.34175 3.61916 6.5894 2.98792 7.8686 2.98792L9.5 2.98713V0.12592C9.2177 0.087075 8.24938 0 7.1228 0C4.77065 0 3.16034 1.49078 3.16034 4.22869V6.58796H0.5V9.78705H3.16026V17.9958L6.34175 17.9957Z",
    fill: "#49C5B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0a99910dcd65e7bf9f2ebb77995fac88.svg";
export { ForwardRef as ReactComponent };